import React, { memo, useCallback, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  addApplicantRequest,
  clearApplicantValues,
  setShowPrompt,
} from "../../../redux/applicant/actions";
import { uploadImage } from "../../../redux/storage/actions";
import { ApplicantType } from "../../../core/entities/applicant";
import ApplicantDetailsStepperPage from "./ApplicantDetailsStepperPage";
import { fetchPositions } from "../../../redux/position/action";

const ApplicantDetailsStepperContainer = () => {
  const showPrompt = useSelector(
    (state: RootStateOrAny) => state.applicant.show_prompt
  );
  const image = useSelector((state: RootStateOrAny) => state.storage.imagePath);

  const isUploading = useSelector(
    (state: RootStateOrAny) => state.storage.isLoading
  );

  const positions = useSelector(
    (state: RootStateOrAny) => state.position.positions
  );

  const error = useSelector((state: RootStateOrAny) => state.applicant.error);
  const isAddSuccessful = useSelector(
    (state: RootStateOrAny) => state.applicant.isAddSuccessful
  );

  const isLoading = useSelector(
    (state: RootStateOrAny) => state.applicant.isLoading
  );

  const isLoadingPosition = useSelector(
    (state: RootStateOrAny) => state.position.isLoading,
  );

  const dispatch = useDispatch();
  const dispatchSetShowPrompt = useCallback(
    (value: RootStateOrAny) => dispatch(setShowPrompt(value)),
    [dispatch]
  );

  const dispatchUploadFile = useCallback(
    (file: Blob | File, fileName: string) =>
      dispatch(uploadImage(file, fileName)),
    [dispatch]
  );
  const dispatchAddApplicant = useCallback(
    (applicant: ApplicantType) => dispatch(addApplicantRequest(applicant)),
    [dispatch]
  );

  const dispatchClearApplicant = useCallback(
    () => dispatch(clearApplicantValues()),
    [dispatch]
  );

  useEffect(() => {
    dispatch(fetchPositions(undefined, [["status", "==", "Open"]]));
  }, [dispatch]);

  return (
    <ApplicantDetailsStepperPage
      image={image}
      showPrompt={showPrompt}
      isUploading={isUploading}
      positions={positions}
      dispatchSetShowPrompt={dispatchSetShowPrompt}
      dispatchUploadFile={dispatchUploadFile}
      dispatchAddApplicant={dispatchAddApplicant}
      error={error}
      isLoading={isLoading || isLoadingPosition}
      isAddSuccessful={isAddSuccessful}
      clearApplicantValues={dispatchClearApplicant}
    />
  );
};

export default memo(ApplicantDetailsStepperContainer);
